import { userApis } from 'services/UserService/apis';

export const getDefaultLanguage = async (lang: string) => {
  return userApis.language.getDefaultLanguage({ language: lang });
};
